import { useTestSetBreadcrumb } from "./useTestSetBreadcrumb"

const formatBreadcrumb = (text: string) => {
  return text
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

interface TestSetBreadcrumbContentProps {
  segment: string
  isLast: boolean
}

export const TestSetBreadcrumbContent = ({
  segment,
  isLast,
}: TestSetBreadcrumbContentProps) => {
  const { currentDisplayName } = useTestSetBreadcrumb(segment)

  const displayName = currentDisplayName

  return (
    <span className={isLast ? "font-semibold" : ""}>
      {displayName || formatBreadcrumb(segment)}
    </span>
  )
}
